import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router';
import { getApiBaseUrl } from '../../utils';
import { Button } from 'antd';

export function LoginAsPage() {
  const { userId } = useParams() as any;

  const startLogin = useCallback(() => {
    window.location.href = getApiBaseUrl() + '/login-as/' + userId;
  }, [userId]);

  useEffect(() => {
    startLogin();
  }, [startLogin]);

  return (
    <>
      <div style={{ padding: '15rem 0', textAlign: 'center' }}>
        <h1>Giriş yapmalısınız!</h1>
        <h3>Uygulamayı kullanmak için giriş yapmalısınız.</h3>
        <Button type="default" style={{ marginTop: '3rem' }} onClick={startLogin}>
          {userId} ID'li kullanıcı ile giriş yapılıyor
        </Button>
      </div>
    </>
  );
}
